import CodeEditor from './CodeEditor';
import ConfigEditor from './ConfigEditor';
import LargeFileViewer from './LargeFileViewer';

const EditorModal = ({
  editor,
  onChangeContent,
  onClose,
  onSave,
  languageOverride,
  onLanguageChange,
  softWrap,
  onToggleWrap,
  configEditor,
  editorView = 'raw',
  onChangeView = () => {},
  onNavigateLargeChunk = () => {},
  loadingLargeFile = false
}) => {
  if (!editor) return null;
  return (
    <div className="fixed inset-0 z-20 flex items-center justify-center bg-black/60 p-4 backdrop-blur">
      <div className="glass-panel w-full max-w-4xl rounded-2xl p-4">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm font-semibold text-textMuted">
              {editor.isRemote ? 'Remote file' : 'Local file'}
            </p>
            <h3 className="text-lg font-semibold text-white">{editor.path}</h3>
          </div>
          <div className="flex flex-wrap items-center gap-2">
            {configEditor && !editor?.isLargeFile ?
            <div className="flex items-center gap-2">
                <button
                type="button"
                className={`ghost-button ${editorView === 'config' ? 'border-accent text-accent' : ''}`}
                onClick={() => onChangeView('config')}>
                
                  Config
                </button>
                <button
                type="button"
                className={`ghost-button ${editorView === 'raw' ? 'border-accent text-accent' : ''}`}
                onClick={() => onChangeView('raw')}>
                
                  Raw
                </button>
              </div> :
            null}
            <button type="button" className="ghost-button" onClick={onClose}>
              Close
            </button>
            <button
              type="button"
              className="pill-button px-4 py-2"
              onClick={onSave}
              disabled={editor?.isImage || editor?.isLargeFile}>
              Save
            </button>
          </div>
        </div>
        <div className="mt-4 h-[420px]">
          {editor.isImage ?
          <div className="h-full w-full rounded-xl border border-border bg-[#11141b] overflow-auto flex items-center justify-center p-4">
            <img
              src={editor.imageUrl}
              alt={editor.path}
              className="max-w-full max-h-full object-contain rounded"
              draggable={false} />
          </div> :
          editor.isLargeFile ?
          <LargeFileViewer
            editor={editor}
            onNavigateChunk={onNavigateLargeChunk}
            loading={loadingLargeFile}
            languageOverride={languageOverride}
            onLanguageChange={onLanguageChange}
            softWrap={softWrap}
            onToggleWrap={onToggleWrap} /> :
          configEditor && editorView === 'config' ?
          <ConfigEditor
            editor={editor}
            config={configEditor}
            onChangeContent={onChangeContent} /> :

          <CodeEditor
            value={editor.content}
            onChange={onChangeContent}
            path={editor.path}
            languageOverride={languageOverride}
            onLanguageChange={onLanguageChange}
            softWrap={softWrap}
            onToggleWrap={onToggleWrap}
            onSave={onSave} />

          }
        </div>
      </div>
    </div>);

};

export default EditorModal;
